module.exports = __webpack_public_path__ + "static/assets/289fa49f4909a6784cd1b8d3bc11caf8.gif";